import { useTranslation } from "react-i18next";
import { connect, useDispatch } from "react-redux";
import { userStatuses } from "../../../app/config/userStatuses";
import { fetchConsumers, setFilter } from "../../../app/slices/consumersSlice";
import { FilterMenu } from "../../filterMenu";
import { ScreenHeader } from "../../screenHeader";
import {format} from "../../../utils/timeZoneUtils";
import ConsumerService from "../../services/ConsumerService";
import {complainStatuses} from "../../../app/config";
import {useEffect} from "react";


function ConsumersTableFilter({ filter, setFilter }) {
  const { t } = useTranslation('ConsumersScreen', { keyPrefix: 'TableFilter' });
  const { t: t_common } = useTranslation('Common');

  let handleFilterChange = (field, value) => {
    setFilter(field, value?.value ?? value);
  };
  
  const handleDownloadCsv = async () => {
    await ConsumerService.downloadCsvReport(filter);
  }
  
  return (
    <>
      <ScreenHeader withSearch search={filter.search} onChange={(event) => handleFilterChange('search', event.target.value)} />
      <div className="fk-filter-container --only-filter">
        <div className="fk-filter">
          <FilterMenu
            datepicker
            label={t('joinDate.text')}
            options={[]}
            selected={filter.dateFrom}
            buttonText={`${t('joinDate.from')} ${filter.dateFrom ? format(filter.dateFrom, "YYYY-MM-DD") : ''}`}
            onChange={(option) => handleFilterChange('dateFrom', option)}
          />
          <FilterMenu
            datepicker
            options={[]}
            selected={filter.dateTo}
            buttonText={`${t('joinDate.to')} ${filter.dateTo ? format(filter.dateTo, "YYYY-MM-DD") : ''}`}
            onChange={(option) => handleFilterChange('dateTo', option)}
          />
          <FilterMenu
            label={t('status.text')}
            options={userStatuses}
            selected={userStatuses.find(s => s.value === filter.isBlocked)}
            onChange={(option) => handleFilterChange('isBlocked', option)}
            tFunc={t}
            tPrefix="status."
          />
          <FilterMenu
              actionButton
              onClick={handleDownloadCsv}
              buttonText={t_common('downloadCsv')}
          />
        </div>
      </div>
    </>
  );
}

export default ConsumersTableFilter;